import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { counterpartyKeys } from '@/services/query-keys';
import { counterpartyService } from '@/services/counterparty/counterparty-service';

/** No counterparty with that id: retrying it cannot succeed. */
export const isCounterpartyNotFound = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 404;

export const useCounterpartyDetail = (id: number) => {
  return useQuery({
    queryKey: counterpartyKeys.detail(id),
    queryFn: () => counterpartyService.getCounterpartyDetail(id),
    enabled: !!id,
    // NOTE: mirrors the app's single retry (`services/query-client.ts`), minus a 404. Being
    // the query's own option, it also overrides a test client's `retry: false`.
    retry: (failureCount, error) => !isCounterpartyNotFound(error) && failureCount < 1,
  });
};
